var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDecoration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.263,
    height: 32,
    viewBox: "0 0 25.263 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_42",
    transform: "translate(-9 -5)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentcolor",
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(9 5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M21.632,38.263A12.632,12.632,0,1,1,34.263,25.632,12.615,12.615,0,0,1,21.632,38.263Zm0-23.579A10.947,10.947,0,1,0,32.579,25.632,10.926,10.926,0,0,0,21.632,14.684Z",
    transform: "translate(-9 -6.263)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M26.579,14.053a.8.8,0,0,1-.842-.842V11.526a.8.8,0,0,0-.842-.842H21.526a.8.8,0,0,0-.842.842v1.684a.842.842,0,1,1-1.684,0V11.526A2.481,2.481,0,0,1,21.526,9h3.368a2.481,2.481,0,0,1,2.526,2.526v1.684A.8.8,0,0,1,26.579,14.053Z",
    transform: "translate(-10.579 -5.632)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M23.842,10.053A.8.8,0,0,1,23,9.211V5.842a.842.842,0,1,1,1.684,0V9.211A.8.8,0,0,1,23.842,10.053Z",
    transform: "translate(-11.211 -5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M19.519,32.721a1.618,1.618,0,0,1-1.011-.337,1.6,1.6,0,0,1-.589-1.853l.842-2.611-2.189-1.6a1.6,1.6,0,0,1-.589-1.853,1.721,1.721,0,0,1,1.6-1.179h2.695l.842-2.611a1.721,1.721,0,0,1,1.6-1.179,1.617,1.617,0,0,1,1.6,1.179h0l.842,2.611h2.695a1.617,1.617,0,0,1,1.6,1.179,1.562,1.562,0,0,1-.589,1.853l-2.189,1.6.842,2.611a1.6,1.6,0,0,1-.589,1.853,1.773,1.773,0,0,1-2.021,0l-2.189-1.6-2.189,1.6A1.618,1.618,0,0,1,19.519,32.721ZM17.5,24.974l2.189,1.6a1.6,1.6,0,0,1,.589,1.853l-.842,2.611,2.189-1.6a1.773,1.773,0,0,1,2.021,0l2.189,1.6-.842-2.611a1.6,1.6,0,0,1,.589-1.853l2.189-1.6H25.076a1.721,1.721,0,0,1-1.6-1.179l-.842-2.611h0l-.842,2.611a1.721,1.721,0,0,1-1.6,1.179Z",
    transform: "translate(-10.087 -7.289)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecoration);
export default __webpack_public_path__ + "static/media/decoration.0bb725761589e75ff28bae17b5a00789.svg";
export { ForwardRef as ReactComponent };